export default function NavAiBadge() {
    return (
        <span className="ms-auto shrink-0 rounded-md bg-gradient-to-r from-violet-600 via-fuchsia-500 to-indigo-600 px-1.5 py-0.5 text-[9px] font-bold uppercase tracking-[0.12em] text-white shadow-[0_0_12px_rgba(139,92,246,0.45)]">
            AI
        </span>
    );
}
